import React from 'react'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import FieldSelect from '../../../../../../containers/fields/FieldSelect'
import EmailInputWithInterpolation from '../../../../../../packages/kiti-editor/components/input/EmailInputWithInterpolation'
import InputWithInterpolations from '../../../../../../packages/kiti-editor/components/input/InputWithInterpolations'

const SlackSentenceSendDm = () => {
  const [open, setOpen] = React.useState()
  const { form } = useFormState()

  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)
  const interpolationGallery = interpolations.filter(i => i.type === 'gallery')

  const isFieldValueFunction = (form.payload?.user?.email || '').startsWith('{{#find_field_value')

  return (
    <>
      <Text size="h2">para o</Text>

      <EditableSentence label={'email'} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <Col width="100%" gu>
          <FormItem
            label="Usuário"
            path={['payload', 'user', 'email']}
            Input={EmailInputWithInterpolation}
            interpolations={interpolations}
            customTypes={['place']}
          />
        </Col>

        {isFieldValueFunction && (
          <>
            <Separator weight={4} />

            <Col width="100%">
              <FormItem
                label="Selecionar campo adicional"
                path={['payload', 'user', 'field_origin_email']}
                Input={FieldSelect}
                useOriginAsLabel
              />
            </Col>
          </>
        )}

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label="Anexos"
            path={['payload', 'attachments']}
            Input={InputWithInterpolations}
            interpolations={interpolationGallery}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label="Mensagem" path={['payload', 'message']} Input={Textarea} />
        </Col>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default SlackSentenceSendDm
